import bookingAPI from "@/api/booking";
import types from "../types";

// initial state
const state = {
  booking: null,
  cruiseTicketURL: null,
};

// getters
const getters = {
  [types.getters.booking]: (state) => state.booking,
  [types.getters.cruiseTicketURL]: (state) => state.cruiseTicketURL,
};

// actions
const actions = {
  [types.actions.searchBooking]({ commit }, { bookingCode, lastName }) {
    commit(types.mutations.setIsLoading, {
      isLoading: true,
      loadingText: "Loading...",
    });

    return bookingAPI
      .searchBooking(bookingCode, lastName)
      .then((result) => {
        console.log("[actions.searchBooking] result:", result);

        const {
          booking,
          cabinConfigurations,
          contacts,
          contactBookings,
          visaRequirements,
          preArrangements,
          postArrangements,
          passports,
          accessToken,
          expiryTime,
        } = result;
        contacts.sort((a, b) => {
          if (a.isPrimaryContact) {
            return -1;
          }

          if (b.isPrimaryContact) {
            return 1;
          }

          return 0;
        });
        commit(types.mutations.setBooking, booking);
        commit(types.mutations.setCabinConfigurations, cabinConfigurations);
        commit(types.mutations.setContacts, contacts);
        commit(types.mutations.setContactBookings, contactBookings);
        commit(types.mutations.setVisaRequirements, visaRequirements);
        commit(types.mutations.setPassports, passports);
        commit(types.mutations.setPreArrangements, preArrangements);
        commit(types.mutations.setPostArrangements, {
          postArrangements,
          booking,
        });
        commit(types.mutations.setAccessToken, accessToken);
        commit(types.mutations.setExpiryTime, expiryTime);

        if (booking.bookingCheckedIn && booking.ticketURLs) {
          commit(types.mutations.setCruiseTicketURL, booking.ticketURLs);
        }

        return result;
      })
      .finally(() => {
        commit(types.mutations.setIsLoading, {
          isLoading: false,
          loadingText: "Loading...",
        });
      });
  },
  [types.actions.updateBookingField]({ commit }, { fieldName, value }) {
    commit(types.mutations.updateBookingField, { fieldName, value });
  },
  [types.actions.updateBookingRemote](
    { commit },
    { booking, showLoader = true },
  ) {
    if (!booking.isDirty) {
      return Promise.resolve();
    }

    showLoader && commit(types.mutations.setIsLoading, { isLoading: true });

    return bookingAPI
      .updateBooking(booking)
      .then((res) => {
        commit(types.mutations.resetBookingDirtyFlag);
        return res;
      })
      .finally(() => {
        showLoader &&
          commit(types.mutations.setIsLoading, { isLoading: false });
      });
  },
  [types.actions.confirmBookingRemote](
    { commit, dispatch },
    {
      contacts,
      visaRequirements,
      passports,
      cabinConfigurations,
      booking,
      preArrangements,
      postArrangements,
    },
  ) {
    commit(types.mutations.setIsLoading, {
      isLoading: true,
      loadingText: "Please wait, this may take a little while...",
    });

    return Promise.all([
      dispatch(types.actions.updateBookingRemote, {
        booking,
        showLoader: false,
      }),
      dispatch(types.actions.updateContactsAndVisaRequirementsRemote, {
        contacts,
        visaRequirements,
        passports,
        showLoader: false,
      }),
      dispatch(types.actions.updateCabinConfigurationRemote, {
        cabinConfigurations,
        showLoader: false,
      }),
      dispatch(types.actions.updatePrePostArrangementsRemote, {
        prePostArrangements: preArrangements.concat(postArrangements),
        showLoader: false,
      }),
    ]).then(() => {
      return bookingAPI
        .confirmBooking(booking)
        .then((cruiseTicketURLByCabinConfigurations) => {
          console.log(
            "cruiseTicketURLByCabinConfigurations:",
            cruiseTicketURLByCabinConfigurations,
          );
          commit(
            types.mutations.setCruiseTicketURL,
            cruiseTicketURLByCabinConfigurations,
          );
          return cruiseTicketURLByCabinConfigurations;
        })
        .finally(() => {
          commit(types.mutations.setIsLoading, { isLoading: false });
        });
    });
  },
  [types.actions.sendCruiseTicketEmailRemote](
    { commit },
    { cabinConfigurations, email, name },
  ) {
    return bookingAPI.sendCruiseTicketEmail(cabinConfigurations, email, name);
  },
};

// mutations
const mutations = {
  [types.mutations.setBooking](state, booking) {
    state.booking = booking;
  },
  [types.mutations.updateBookingField](state, { fieldName, value }) {
    state.booking[fieldName] = value;
    state.booking.isDirty = true;
  },
  [types.mutations.resetBookingDirtyFlag](state) {
    state.booking.isDirty = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/booking.js